/**
 * Created by lenovo on 2017/3/13.
 */
import React,{Component} from 'react'
export default class Tip extends Component{
    constructor(props){
        super(props);
    }
    render(){
        const ids = this.props.ids;
        return (
            <div>
                <div tabIndex="0" id={ids.errTip ==undefined?"error_tip":ids.errTip} className="hidden alert-tip">
                    <div className="alert alert-danger">
                        <strong>错误！</strong>
                        <button type="button" className="close" data-dismiss='alert'>×</button>
                       <span id={ids.errMsg ==undefined?"error_msg":ids.errMsg}>操作失败.</span>
                    </div>
                </div>
                <div tabIndex="0" id={ids.sucTip ==undefined?"success_tip":ids.sucTip} className="hidden alert-tip">
                    <div className="alert alert-success">
                        <strong>成功！</strong>
                        <button type="button" className="close" data-dismiss='alert'>×</button>
                        <span id={ids.sucMsg == undefined?"success_msg":ids.sucMsg}>操作成功.</span>
                    </div>
                </div>
                <div tabIndex="0" id={ids.warnTip ==undefined?"warning_tip":ids.warnTip} className="hidden alert-tip">
                    <div className="alert alert-warning">
                        <strong>警告！</strong>
                        <button type="button" className="close" data-dismiss='alert'>×</button>
                        <span id={ids.warnMsg ==undefined?"warning_msg":ids.warnMsg}>操作失败.</span>
                    </div>
                </div>
            </div>
        )
    }
}
//提示
//<Tip ids={{"errTip":"","errMsg":"","sucMsg":"","sucTip":""}}/>


// WEBPACK FOOTER //
// ./modules/component/tip.js